import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { MeetingsService } from '../organizations/organizations-detail/organizations-meetings-detail/meetings.service';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';

import { OrganizationsService } from '../organizations/organizations.service';
import { OrganizationsMeetingsDetailComponent } from '../organizations/organizations-detail/organizations-meetings-detail/organizations-meetings-detail.component';
import { DialogService } from 'primeng/dynamicdialog';
import { ActivatedRoute } from '@angular/router';
import esLocale from '@fullcalendar/core/locales/es';
import { UsersService } from '../users/users.service';
import { LoginService } from '../login/login.service';
import { MeetingStatesService } from '../organizations/organizations-detail/organizations-meetings-detail/meeting-states.service';
import { ViewComponent } from '../core/view/view.component';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit {
  @ViewChild("view") public view: ViewComponent;
  public writeMeeting: boolean = true;
  public userId = null;
  public isSuperAdmin = "false";
  public selectedOrganization: any;
  public selectedState: any;
  public selectedOrganizationId: number = null;
  public selectedStateId: number = null;
  public subject: any;
  public organizations: any[];
  public states: any[];
  public selectedUsers: any[];
  public names: any[];
  public users: any[];
  public user: any;
  public connectedUserPermission: any;
  public tooltip_info = {
    show: false,
    description: "",
    showType: "",
    date_from: "",
    date_to: "",
    responsible: "",
    organization: "",
    duration: "",
    state: "",
    allDay: false,
    participants: [],
    backgroundColor: '#ceede6',
    textColor: "black",
  };
  public xPos = "0px";
  public yPos = "0px";

  public events: any[] = [];
  public from_date: Date = null;
  public to_date: Date = null;
  public options: any = {
    locale: esLocale,
    navLinks: true,
    plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
    defaultDate: new Date(),
    scrollTime: '06:00:00',
    scrollTimeReset: true,
    contentHeight: 650,
    headerToolbar: {
      left: 'prev,next',
      center: 'title',
      right: 'dayGridMonth,timeGridWeek,timeGridDay'
    },
    eventClick: (e) => {
      //Se activa cuando haces clic en un evento.

      //Recoge valores:
      var event_id = e.event._def.extendedProps.event_id;
      var type = e.event._def.extendedProps.type;

      //Abre un popup u otro dependiendo del tipo de entidad:
      if (type == 'meeting') this.meetingService.get(event_id).subscribe(
        data => {
          var meeting;
          meeting = data;
          this.viewMeeting(meeting, null);
        }
      )
    },
    dateClick: (e) => {
      //Se activa cuando haces clic en una fecha.
      console.log(e);
      this.viewMeeting(null, e.date);
    },
    editable: true,
    datesSet: (e) => {
      this.handleDatesRender(e);
    },
    eventMouseEnter: (e) => {
      window.addEventListener("mousemove", (e) => {
        this.xPos = (e.clientX + 46) + "px";
        this.yPos = (e.clientY + 32) + "px";
      });
      console.log("event -> ", e.event);
      console.log("tooltip_info -> ", this.tooltip_info);
      this.tooltip_info.description = e.event._def.extendedProps.subject;
      this.tooltip_info.show = true;
      this.tooltip_info.showType = e.event._def.extendedProps.showType;
      this.tooltip_info.date_from = (e.event._def.allDay != true ? e.event._def.extendedProps.date_from : "");
      this.tooltip_info.date_to = e.event._def.extendedProps.date_to;
      this.tooltip_info.responsible = e.event._def.extendedProps.responsible;
      this.tooltip_info.organization = e.event._def.extendedProps.organization;
      this.tooltip_info.duration = (e.event._def.allDay == true ? "Todo el día" : this.getTimeOfEvent(e.event._def.extendedProps.duration));
      this.tooltip_info.participants = e.event._def.extendedProps.participants;
      this.tooltip_info.state = e.event._def.extendedProps.state;
      this.tooltip_info.allDay = e.event._def.allDay;
      this.tooltip_info.backgroundColor = e.event.backgroundColor;
      this.tooltip_info.textColor = this.lightOrDark(e.event.backgroundColor) == "dark"?"white":"black";
    },
    eventMouseLeave: (e) => {
      this.tooltip_info.show = false;
    },
    eventResize: (e) => {
      console.log(e);
      this.modifyEvent(e.event._def.extendedProps, e.endDelta, "resize");
    },
    eventDrop: (e) => {
      console.log(e);
      this.modifyEvent(e.event._def.extendedProps, e.delta, "drop");
    },
    slotLabelFormat: {
      hour: '2-digit',
      minute: '2-digit',
      meridiem: false
    },
    eventTimeFormat: {
      hour: '2-digit',
      minute: '2-digit',
      meridiem: false
    },
    eventDidMount: function (info) {
    }
  };

  constructor(
    public meetingService: MeetingsService,
    public messageService: MessageService,
    public organizationService: OrganizationsService,
    public dialogService: DialogService,
    public route: ActivatedRoute,
    private usersService: UsersService,
    public loginService: LoginService,
    public meetingStatesService: MeetingStatesService
  ) {
    this.writeMeeting = this.loginService.hasPermission("MEETINGS_WRITE");
    this.userId = localStorage.getItem("userId");
    this.isSuperAdmin = localStorage.getItem("isSuperAdmin");
    if (this.route.snapshot.paramMap.has('id')) this.selectedOrganizationId = parseInt(this.route.snapshot.paramMap.get('id'));
  }


  ngOnInit(): void {
    console.log("ngOnInit calendarcomponent")
    this.loadUser();
    this.loadOrganizations(null);
    this.loadStates(null);
  }

  loadUser() {
    this.usersService.get(this.loginService.get("userId")).subscribe(
      data => {
        this.user = data;
        this.selectedUsers = this.user.metadata?.calendarConfig?.selectedUsers;
        if (this.selectedUsers == null || this.selectedUsers.length == 0) this.selectedUsers = [parseInt(localStorage.getItem("userId"))];
        this.loadUsers();
        this.loadMeeting();
      },
      error => this.messageService.add({ closable: false, severity: "error", detail: error.error.title })
    );
  }

  loadMeeting() {
    let parameters = {
      check_invited_users: true, //busca tambien en invitados
      from_date: this.from_date.toISOString(),
      to_date: this.to_date.toISOString()
    };
    if (this.selectedOrganizationId != null) Object.assign(parameters, { organization_id: this.selectedOrganizationId });
    if (this.selectedStateId != null) Object.assign(parameters, { meeting_state_id: this.selectedStateId });
    if (this.selectedUsers != null && this.selectedUsers.length > 0) {
      Object.assign(parameters, { usersIds: this.selectedUsers });
    } else {
      Object.assign(parameters, { usersIds: [parseInt(localStorage.getItem("userId"))] });
    }

    if (this.subject != null) Object.assign(parameters, { subject: this.subject });
    this.meetingService.all(parameters).subscribe(
      data => {
        this.events = data.rows.map(m => {
          var title = "";
          if (m.organization?.name != null || m.organization?.tradename) {
            title += "(";
            if (m.organization?.name != null) {
              title += m.organization?.name;
              if (m.organization?.tradename != null) title += ", ";
            }
            if (m.organization?.tradename != null) title += m.organization.tradename;
            title += ")";
          };

          var isCreator = (this.userId == m.created_by);
          var isResponsible = (this.userId == m.responsible_id);

          return {
            title: m.subject + " " + title,
            subject: m.subject,
            start: m.from,
            end: m.to,
            event_id: m.id,
            created_by: m.created_by,
            responsible_id: m.responsible_id,
            date_from: m.from,
            date_to: m.to,
            type: 'meeting',
            allDay: m.allDay,
            showType: "Reunión",
            responsible: m.responsible?.name,
            organization: (m.organization?.name ? m.organization.name : "") + (m.organization?.tradename ? " (" + m.organization.tradename + ")" : ""),
            duration: m.duration,
            display: 'block',
            backgroundColor: m.responsible.color ? m.responsible.color : "#e8e8e8",
            //textColor: "black",
            textColor: this.lightOrDark(m.responsible.color ? m.responsible.color : "#e8e8e8") == "dark"?"white":"black",
            participants: m.meetingUsers,
            state: m.state?.name,
            editable: this.loginService.canEditModel(m, this.view?.entity?.code) //(this.isSuperAdmin === "true" || (this.writeMeeting && (this.loginService.canEditModel(m, this.view?.entity?.code) || isCreator))) //(this.isSuperAdmin === "true" || (this.writeMeeting && (isCreator || isResponsible)))
          };
        });
      },
      error => this.messageService.add({ closable: false, severity: "error", detail: error.error.title })
    );
    //if (this.selectedUsers) this.loadNames();
  }

  saveSelectedUsers() {
    this.user.metadata["calendarConfig"] = { "selectedUsers": this.selectedUsers };
    this.usersService.save(this.user.id, this.user).subscribe(
      data => {
        this.user = data;
        this.loadMeeting();
      },
      error => this.messageService.add({ closable: false, severity: "error", detail: error.error.title })
    )
  }

  onChangeUser(user) {
    let idx = this.selectedUsers.indexOf(user.id);
    if (idx >= 0) {
      this.selectedUsers.splice(idx, 1);
      user.selected = false;
    } else {
      this.selectedUsers.push(user.id);
      user.selected = true;
    }
    this.saveSelectedUsers();
  }

  lightOrDark(color) {

    // Variables for red, green, blue values
    var r, g, b, hsp;

    // Check the format of the color, HEX or RGB?
    if (color.match(/^rgb/)) {

      // If RGB --> store the red, green, blue values in separate variables
      color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

      r = color[1];
      g = color[2];
      b = color[3];
    }
    else {

      // If hex --> Convert it to RGB: http://gist.github.com/983661
      color = +("0x" + color.slice(1).replace(
        color.length < 5 && /./g, '$&$&'));

      r = color >> 16;
      g = color >> 8 & 255;
      b = color & 255;
    }

    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    hsp = Math.sqrt(
      0.299 * (r * r) +
      0.587 * (g * g) +
      0.114 * (b * b)
    );

    // Using the HSP value, determine whether the color is light or dark
    if (hsp > 127.5) {

      return 'light';
    }
    else {

      return 'dark';
    }
  }

  getUserCheckClass(user: any) {
    let className = "checkbox-color-black";
    if (user.color) {
      let hexColor = user.color.replace("#", "");
      className = this.lightOrDark(hexColor) == "dark" ? 'checkbox-color-white' : 'checkbox-color-black';
    }
    return "checkbox-no-bg " + className;
  }

  onOrganizationChange() {
    this.selectedOrganizationId = this.selectedOrganization != null ? this.selectedOrganization.id : null;
    this.loadMeeting();
  }
  onStateChange() {
    this.selectedStateId = this.selectedState != null ? this.selectedState.id : null;
    this.loadMeeting();
  }

  loadOrganizations(event) {
    let params: any = {};
    if (event != null) params.searchText = event.filter;
    if (this.selectedOrganizationId != null) params.include_organization_id = this.selectedOrganizationId;
    this.organizationService.getCombo(params).subscribe(
      data => {
        this.organizations = data.rows;
        //this.organizations.unshift({ name: "Todas", id: null });
        if (this.selectedOrganizationId != null) this.selectedOrganization = this.organizations.find(m => m.id == this.selectedOrganizationId);
      },
      error => this.messageService.add({ closable: false, severity: "error", detail: error.error.title })
    );

  }

  loadStates(event) {
    let params: any = {};
    if (event != null) params.searchText = event.filter;
    if (this.selectedStateId != null) params.include_state_id = this.selectedStateId;
    this.meetingStatesService.all({}).subscribe(
      data => {
        this.states = data.rows;
        //this.states.unshift({ name: "Todos", id: null });
        if (this.selectedOrganizationId != null) this.selectedState = this.states.find(m => m.id == this.selectedStateId);
      },
      error => {
        this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
      }
    );
  }

  loadUsers() {

    //si no puedes ver otros calendarios, solo le añadimos a el
    if (!this.loginService.hasPermission("CALENDAR_OTHERS_USERS")) {
      this.selectedUsers = [localStorage.getItem("userId")];
      return;
    }

    //cargamos otros usuarios
    this.meetingService.users({}).subscribe(
      data => {
        this.users = data.rows;
        if (this.selectedUsers != null) {
          this.users.forEach(user => {
            if (this.selectedUsers.indexOf(user.id) >= 0) user.selected = true;
          });
        }
      },
      error => this.messageService.add({ closable: false, severity: "error", detail: error.error.title })
    )
  }
  viewMeeting(meeting, from: null) {
    const ref = this.dialogService.open(OrganizationsMeetingsDetailComponent, {
      data: {
        id: meeting ? meeting.organization_id : null,
        contactId: meeting ? meeting.contact_id : 0,
        meetingId: meeting ? meeting.id : 0,
        deactivated: meeting ? true : false,
        from: from ? from : null
      },
      //header: meeting ? "Detalles de la reunión" : "Nueva reunión",
      width: '70%',
      /*baseZIndex: 999*/
    });
    ref.onClose.subscribe((data: any) => {
      this.loadMeeting();
    })
  }

  modifyEvent(props, delta, action) {
    if (props.type == "meeting") this.saveMeeting(props, delta, props.event_id, action);
  }

  calcNewDate(originalDate, delta) {
    var newDate = new Date(originalDate);

    if (delta.years) {
      newDate.setFullYear(newDate.getFullYear() + delta.years);
    }

    if (delta.months) {
      newDate.setMonth(newDate.getMonth() + delta.months);
    }

    if (delta.days) {
      newDate.setDate(newDate.getDate() + delta.days);
    }

    if (delta.milliseconds) {
      newDate.setMilliseconds(newDate.getMilliseconds() + delta.milliseconds);
    }
    return newDate.toISOString();
  }

  calcNewDateTo(date, duration) {
    var dateFrom = new Date(date);
    var dateTo = new Date(dateFrom.getTime() + duration * 60000);
    return dateTo.toISOString();
  }

  calcDuration(date_from, date_to) {
    var startDate = new Date(date_from);
    var endDate = new Date(date_to);
    var duration = endDate.getTime() - startDate.getTime();
    return duration / 60000;
  }


  saveMeeting(props, delta, meeting_id, action) {

    if (action == "drop") {
      var new_date_from = this.calcNewDate(props.date_from, delta);
      var new_date_to = this.calcNewDateTo(new_date_from, props.duration);
      this.meetingService.setNewDates(meeting_id, { new_date_from: new_date_from, new_date_to: new_date_to, id: meeting_id }).subscribe(
        data => {
          //this.messageService.add({ closable: false, severity: "success", detail: "Evento modificado" });
          this.loadMeeting();
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      );
    }
    if (action == "resize") {
      var new_date_to = this.calcNewDate(props.date_to, delta);
      this.meetingService.setNewDates(meeting_id, { new_date_to: new_date_to, duration: this.calcDuration(props.date_from, new_date_to) }).subscribe(
        data => {
          //this.messageService.add({ closable: false, severity: "success", detail: "Evento modificado" });
          this.loadMeeting();
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      );
    }
  }

  handleDatesRender($event) {
    console.log($event);
    this.from_date = $event.start;
    this.to_date = $event.end;
    this.loadMeeting();
  }

  getTimeOfEvent(duration) {
    //Éste método devuelve una cadena de texto con la duración del evento en el formato X h XX m.

    var durationText = "";
    if (duration >= 60) {
      var hours = Math.floor(duration / 60);
      var minutes = duration % 60;
      if (hours === 1) {
        //Si se necesita, se puede poner aquí "hora":
        durationText = "1 h";
      } else {
        //Si se necesita, se puede poner aquí "horas":
        durationText = hours + " h";
      }
      if (minutes > 0) {
        durationText += " ";
        if (minutes === 1) {
          //Si se necesita, se puede poner aquí "minuto":
          durationText += "1 min.";
        } else {
          //Si se necesita, se puede poner aquí "minutos":
          durationText += minutes + " min.";
        }
      }
    } else {
      //Si se necesita, se puede poner aquí "minutos":
      durationText = duration + " min.";
    }
    return durationText;
  }
}
